import { NgModule } from '@angular/core';
import { InteractDirective } from './interact.directive';



@NgModule({
  declarations: [InteractDirective],
  imports: [
  ],
  exports: [InteractDirective]
})
export class NgxInteractjsModule { }
